import { MASTER_PROJECT_TYPE, SHADOW_PROJECT_TYPE } from '../../constants';

export type LoginProjectData = UserStatistic &
  MauStatistic & {
    game_pages: Array<string>;
    id: string;
    login_urls: Array<string>;
    name: string;
    publisher_id: number;
    updated_at?: string;
  };

export type MauStatistic = {
  mau?: Data;
};

export type CheckListItems = {
  [ley: string]: boolean;
};

export type UserStatistic = {
  users?: number;
  new_users?: Data;
};

export type Data = { current: number; change: number };

export type LoginType = typeof SHADOW_PROJECT_TYPE | typeof MASTER_PROJECT_TYPE;

export type CreateLoginParams = {
  name: string;
  type: LoginType;
  game_pages?: Array<string>;
  updated_at?: string;
  description?: string;
  is_ng_verification?: boolean;
};

export type CreateLoginResponse = {
  id: string;
};

export type getConnectedLaunchersProps = {
  merchantId: number;
  loginProjectId: string;
};

type Game = {
  id: number;
  publisher_project_id: number;
  game_page_enabled: boolean;
  ordering: number;
  name: string;
};

export type ConnectedLauncher = {
  created_at: number;
  external_id: string;
  games: Array<Game>;
  is_mf_enabled: boolean;
  launcher_template_release_id: number;
  name: string;
  publisher_id: number;
  status: OldLauncherStatus;
  xsolla_login_project_id: string;
};

export enum OldLauncherStatus {
  configuration = 'configuration',
  not_active = 'not_active',
  active = 'active'
}

export type ConnectedLaunchers = Array<ConnectedLauncher>;

export type ConnectedLauncherNew = {
  id: number;
  login_project_id: string;
  sec_uuid: string;
  updated_at: string;
};

export type ConnectedLaunchersNew = Array<ConnectedLauncherNew>;
